import {getCheckoutSummary, getTaxLabel} from '@wix/wix-events-commons-statics'
import {membersPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {EventText} from '../../../../../../commons/components/event-text/event-text'
import {useMembersPageCurrencyFormatter} from '../../../hooks/currency'
import {DividerExt as Divider} from '../../styled-components/divider/divider'
import sc from '../common.scss'
import {Price} from '../price/price'
import {SubtotalsProps} from './interfaces'
import s from './subtotals.scss'

export const Subtotals = ({invoice}: SubtotalsProps) => {
  const {t} = useTranslation()
  const {getFormattedMoney} = useMembersPageCurrencyFormatter()
  const {subtotal, discount, tax, addedFee, additionalFees, total} = getCheckoutSummary(invoice, getFormattedMoney)
  const taxLabel = getTaxLabel(invoice)

  return (
    <>
      {subtotal && (
        <>
          <div className={sc.section} data-hook={DH.SUBTOTALS_CONTAINER}>
            <Price value={subtotal} label={t('mobile.order.subtotal')} dataHook={DH.SUBTOTAL} />
            <Price value={discount} label={t('mobile.order.coupon')} dataHook={DH.DISCOUNT_TOTAL} />
            <Price value={tax} label={taxLabel} dataHook={DH.TAX} />
            {additionalFees.map((fee, index) => (
              <Price key={index} value={fee.amount} label={fee.name} dataHook={DH.ADDITIONAL_FEE(index)} />
            ))}
            <Price value={addedFee} label={t('order.serviceFee')} />
          </div>
          <Divider />
        </>
      )}
      <div className={classNames(s.overallTotal, sc.splitRow)}>
        <EventText>{t('mobile.order.overall.total')}</EventText>
        <EventText>{total}</EventText>
      </div>
    </>
  )
}
